import React from 'react';
import { Icon } from 'semantic-ui-react';

export default ({ index, currentIndex, changeCurrentIndex }) => (
  <Icon
    size="small"
    name={index === currentIndex ? 'circle' : 'circle outline'}
    inverted
    onClick={() => changeCurrentIndex(index)}
  />
);
